import { useSelector } from "react-redux"
import { Navigate, useLocation } from "react-router"
import { RootState } from "../store"
import { PublicRouteProps } from "./RoutingType"

const PublicRoute = ({ Component }: PublicRouteProps) => {
    const location = useLocation()
    let params = new URLSearchParams(location.search)
    const redirectUrl = params.get("redirectUrl") || "/dashboard"
    const isAuthenticated = useSelector((state: RootState) => state.signinSlice.authenticationSlice)
    const authenticated = isAuthenticated.hasAccessToken

    return !authenticated ? <Component /> : <Navigate to={redirectUrl} replace />
}
export default PublicRoute
